import { css } from '@emotion/react';

const buttonStyles = {
  buttonWrapper: css`
    display: inline-block;
  `,

  button: css`
    transition: background-color 0.2s, color 0.2s;
    background: #fbfbfb;
    color: #222;
    font-size: 18px;
    border: 0;
    padding: 0.25rem;
    height: 3rem;
    width: 3rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
    border-radius: 0.25rem;
    &:hover,
    &:focus {
      background: #404040;
      color: #fff;
      outline: 0; /* reset for :focus */
    }
  `,

  active: css`
    background: #707070;
    color: #fff;
  `,

  inactive: css`
    opacity: 0.3;
    cursor: default;
    button {
      pointer-events: none;
      cursor: default;
    }
  `,
};

const toolbarStyles = {
  toolbar: css`
    display: flex;
    align-items: center;
    background: #fff;
    border-top: 1px solid rgba(160, 177, 179);
    border-radius: 0 0 5px 5px;
    z-index: 2;
    padding: 0.25rem;
    box-sizing: border-box;
    &:after {
      border-color: rgba(255, 255, 255, 0);
      border-top-color: #fff;
      border-width: 4px;
      margin-left: -4px;
    }
    &:before {
      border-color: rgba(221, 221, 221, 0);
      border-top-color: #ddd;
      border-width: 6px;
      margin-left: -6px;
    }
  `,
  toolbarOnTop: css`
    border-top: none;
    border-bottom: 1px solid rgba(160, 177, 179);
    border-radius: 5px 5px 0 0;
  `,
};

export const defaultTheme = {
  buttonStyles,
  toolbarStyles,
};
